import { render } from "./v-button.vue?vue&type=template&id=4be26dac&scoped=true&ts=true"
import script from "./v-button.vue?vue&type=script&lang=ts"
export * from "./v-button.vue?vue&type=script&lang=ts"

import "./v-button.vue?vue&type=style&index=0&id=4be26dac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be26dac"]])

export default __exports__